module.exports = __webpack_public_path__ + "static/media/pattern2@2x.9ca264e6.png";